import React from 'react';
import { ExternalLink, Clock } from 'lucide-react';
import { YouTubeVideo } from '../services/youtube';

interface VideoCardProps {
  video: YouTubeVideo;
  onPlay: (videoId: string) => void;
}

const VideoCard: React.FC<VideoCardProps> = ({ video, onPlay }) => {
  const formatDuration = (duration: string) => {
    const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!match) return '';
    
    const hours = match[1] ? `${match[1]}:` : '';
    const minutes = match[2] ? `${match[2]}:` : '0:';
    const seconds = match[3] ? match[3].padStart(2, '0') : '00';
    
    return `${hours}${minutes}${seconds}`;
  };

  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow group">
      <div 
        className="relative cursor-pointer"
        onClick={() => onPlay(video.id)}
      >
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-48 object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-opacity flex items-center justify-center">
          <ExternalLink className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
        </div>
        {/* <div className="absolute bottom-2 right-2 bg-black bg-opacity-75 px-2 py-1 rounded text-white text-sm flex items-center">
          <Clock className="h-3 w-3 mr-1" />
          {formatDuration(video.duration)}
        </div> */}
      </div>
      <div className="p-4">
        <h3 className="font-semibold text-gray-900 mb-2 line-clamp-2">
          {video.title}
        </h3>
        <div className="text-sm text-gray-600 truncate">
          {video.channelTitle}
        </div>
      </div>
    </div>
  );
};

export default VideoCard;